module.exports = __webpack_public_path__ + "static/clayborn-3.48ca6d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/clayborn-3.jpg
// module id = 149
// module chunks = 35783957827783 228922781756548